import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { AddWorkspaceadmin, Adminassignemployeeworkspace } from "../Modal";
import "../../index.css";
import "bootstrap/dist/css/bootstrap.min.css"; 
const Createworkspaceadmin = () => {
  const chartContainer = useRef(null);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [workspacedata, setworkspacedata] = useState([]);
  const [filteredWorkspacedata, setFilteredWorkspacedata] = useState([]);
  const [showaddworkspacetModal, setshowaddworkspacetModal] = useState(false);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null);
  const [showAddEmployeeModal, setShowAddEmployeeModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const getWorkspacedata = async () => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({
          empid: "0",
          firmid: user.firm_id,
          ownerid: user.userid,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetYourWorkspace`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setworkspacedata(data.data);
        setFilteredWorkspacedata(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const getProjects = async () => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        created_by: "Admin",
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmProjects`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        const options = data.data.map((project) => ({
          value: project.pk_project_id,
          label: project.project_name,
        }));

        options.unshift({ value: "", label: "Clear Filter" });

        setProjectOptions(options);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getWorkspacedata();
    getProjects();
  }, []);

  const handleAddEmployeeModalOpen = (workspaceId, projectId) => {
    setSelectedWorkspaceId(workspaceId);
    setSelectedProject(projectId);
    setShowAddEmployeeModal(true);
  };

  const handleAddEmployeeModalClose = () => {
    setShowAddEmployeeModal(false);
  };

  const openaddprojectModal = () => {
    setshowaddworkspacetModal(true);
  };

  const closeaddprojectModal = () => {
    setshowaddworkspacetModal(false);
  };
  const handleProjectChange = (selectedOption) => {
    setSelectedProjectId(selectedOption.value);
    if (selectedOption.value === "") {
      setFilteredWorkspacedata(workspacedata);
    } else {
      const filteredData = workspacedata.filter(
        (item) => item.pk_project_id === selectedOption.value
      );
      setFilteredWorkspacedata(filteredData);
    }
  };

  const handleSearchInputChange = (e) => {
    const inputValue = e.target.value.toLowerCase();
    setSearchInput(inputValue);

    const filteredData = workspacedata.filter((workspace) => {
      return (
        workspace.workspace_name.toLowerCase().includes(inputValue) ||
        workspace.workspce_desc.toLowerCase().includes(inputValue) ||
        workspace.lettersdata.some((employee) =>
          employee.emp_name.toLowerCase().includes(inputValue)
        )
      );
    });

    setFilteredWorkspacedata(filteredData);
  };
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayImageUrl, setOverlayImageUrl] = useState(null);
  const handleImageClick = (imageUrl) => {
    setOverlayImageUrl(imageUrl);
    setShowOverlay(true);
  };
  const handleCloseOverlay = () => {
    setShowOverlay(false);
    setOverlayImageUrl(null);
  };
  return (
    <div className="mt-4" style={{ background: "#fff" }}>
      <div className="row">
        <h4 className="col d-flex align-items-center">
          {user.organisation} Work space
        </h4>
        <div className="col d-flex justify-content-end">
          <div className="px-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search "
              value={searchInput}
              onChange={handleSearchInputChange}
            />
          </div>
          <div className="px-2">
            <Select
              className="basic-single"
              classNamePrefix="select"
              placeholder="Select Project"
              isClearable={true}
              value={selectedProject}
              onChange={handleProjectChange}
              options={projectOptions}
            />
          </div>

          <Button
            className="btn btn-sm justify-content-center align-items-center"
            style={{
              background: "#2ca01c",
              borderRadius: ".4em",
              border: "None",
              color: "#fff",
            }}
            onClick={openaddprojectModal}
          >
            Add Work space
          </Button>
        </div>
      </div>

      <div
  className="table-responsive"
  style={{
    borderRadius: ".4em",
    border: "1px solid lightgrey",
    marginTop: "1rem",
    background: "#fff",
  }}
>
  <table className="table table-bordered m-0">
    <thead className="bg-white" style={{ position: "sticky", top: 0, zIndex: 10 }}>
      <tr style={{ borderBottom: "2px solid #0074D9" }}>
        {["Project", "Work Space", "Description", "Team", "Team Size", "Action"].map(
          (header, idx) => (
            <th
              key={idx}
              className="text-center"
              style={{
                color: "#0074D9",
                borderBottom: "none",
                fontWeight: "400",
                whiteSpace: "nowrap",
              }}
            >
              {header}
            </th>
          )
        )}
      </tr>
    </thead>
    <tbody>
      {filteredWorkspacedata.length === 0 ? (
        <tr>
          <td
            colSpan="6"
            className="text-center py-3"
            style={{ fontSize: "1rem", fontWeight: "500" }}
          >
            No data found
          </td>
        </tr>
      ) : (
        filteredWorkspacedata.map((item, index) => (
          <tr key={index} style={{ borderBottom: "1px solid lightgrey" }}>
            <td className="text-center align-middle p-2" style={{ whiteSpace: "normal",fontSize:".9rem" }}>
              {item.project_name}
            </td>
            <td className="text-center align-middle p-2" style={{fontSize:".9rem"}}>{item.workspace_name}</td>
            <td className="text-center align-middle p-2" style={{ whiteSpace: "normal",fontSize:".9rem" }}>
              {item.workspce_desc}
            </td>
            <td className="text-center align-middle p-2 d-flex justify-content-center flex-wrap">
              {item.lettersdata.map((employee, idx) => (
                <div
                  key={idx}
                  className="initial d-flex flex-column align-items-center mx-1"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: item.colourcode || "#ccc",
                    color: "#fff",
                    fontWeight: "700",
                    fontSize: "1.1rem",
                    cursor: "pointer",
                    overflow: "hidden",
                    position: "relative",
                  }}
                  title={employee.emp_name}
                  onClick={() => handleImageClick(employee.image_url)}
                >
                  {employee.image_url ? (
                    <img
                      src={employee.image_url}
                      alt={employee.emp_name}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      {employee.employee_first_letter}
                    </span>
                  )}
                </div>
              ))}
            </td>
            <td className="text-center align-middle p-2" style={{fontSize:".9rem"}}>{item.teamsize}</td>
            <td className="text-center align-middle p-2" style={{fontSize:".9rem"}}>
              <button
                className="btn btn-link p-0"
                style={{ fontSize: ".8rem" }}
                onClick={() => handleAddEmployeeModalOpen(item.pk_work_id, item.pk_project_id)}
              >
                Assign Employee
              </button>
              &nbsp;&nbsp;
              <Link
                to="/admin/Task-management"
                onClick={() => sessionStorage.setItem("property", JSON.stringify(item))}
                style={{ display: "inline-block" }}
              >
                <img
                  src={require("../../assets/images/arrow.png")}
                  alt="Go to Task Management"
                  style={{ width: 20, height: 20 }}
                />
              </Link>
            </td>
          </tr>
        ))
      )}
    </tbody>
  </table>
</div>

      {showOverlay && overlayImageUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={handleCloseOverlay}
        >
          <img
            src={overlayImageUrl}
            alt="Profile Overlay"
            style={{
              width: "40vmin",
              height: "40vmin",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
      )}
      <AddWorkspaceadmin
        show={showaddworkspacetModal}
        closeModal={closeaddprojectModal}
        getWorkspacedata={getWorkspacedata}
      />

      <Adminassignemployeeworkspace
        isOpen={showAddEmployeeModal}
        onClose={handleAddEmployeeModalClose}
        selectedWorkspaceId={selectedWorkspaceId}
        getWorkspacedata={getWorkspacedata}
        selectedProject={selectedProject}
      />
    </div>
  );
};

export default Createworkspaceadmin;
